export default __webpack_public_path__ + "static/media/logo.22c40b87.png";